/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var ServicesUtils = require('ES/utils/ServicesUtils');
var SlideOpenDown = require('../../widgets/SlideOpenDown');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var AuthedUserSession = require('../../../utils/AuthedUserSession');

module.exports = dd.createClass({
	mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_Infusionsoft_config", "save_Thirdpartyconnection_Infusionsoft_config")],
	__RadioAjax_key_read_Thirdpartyconnection_Infusionsoft_config: function () {
		return this.state.sid;
	},
	__RadioAjax_key_save_Thirdpartyconnection_Infusionsoft_config: function () {
		return this.state.sid;
	},
	getInitialState: function () {
		return {sid: -1};
	},
	componentWillReceiveProps: function (props) {
		this.__loadForSid(props.selected_sid);
	},
	componentDidMount: function () {
		this.__loadForSid(this.props.selected_sid);
	},
	__loadForSid: function (sid) {
		if (sid !== this.state.sid) {
			this.setState({sid: sid}, function () {
				radio('read_Thirdpartyconnection_Infusionsoft_config').broadcast(sid);
			});
		}
	},
	__onSubmit: function (data) {
		radio('save_Thirdpartyconnection_Infusionsoft_config').broadcast(this.state.sid, data);
	},
	render: function () {
		var Displaylists = this.props.Displaylists;

		var sid = this.state.sid;
		var ajax_read = this.state.read_Thirdpartyconnection_Infusionsoft_config;
		var ajax_save = this.state.save_Thirdpartyconnection_Infusionsoft_config;

		var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
			return spkr.sid == sid;
		}, this);

		return dd.div(null,
			LoadingWrap({
					is_loading: ajax_read.waiting || ajax_save.waiting,
					glass: true
				},
				dd.h3(null,
					'Keap connector for ',
					dd.span({className: 'nametag'},
						AuthedUserSession.MY_USERNAME),
					' + ',
					dd.span({className: 'nametag'},
						speaker ? speaker.name_full : '')
				),
				dd.p({className: 'text-muted'},
					'NOTE: The settings for this connector is PER-USER. Each user on the account must individually use this configuration page.'
				),
				ErrorAlert({message: ajax_read.error_message}),
				ErrorAlert({message: ajax_save.error_message}),
				DaForm({
					sid: sid,
					config: ajax_read.data,
					onSubmit: this.__onSubmit
				})
			)
		);
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValuesSourceVersion: function (props) {
		return props.sid + JSON.stringify(this.getInitialValues(props));
	},
	getInitialValues: function (props) {
		var config = props.config || {};
		return {
			app_name: config.app_name || '',
			app_key: config.app_key || '',
			infusionsoft_username: config.infusionsoft_username || '',
			infusionsoft_password: config.infusionsoft_password || ''
		};
	},
	buildFields: function () {
		return {
			app_name: {
				label: 'Keap ACCOUNT CODE',
				type: 'text',
				help_text: 'example: bc423',
				tooltip: 'This is the account code for your Keap account. You can find it by looking at the first part of your Keap URL (just before .infusionsoft.com)'
			},
			app_key: {
				label: 'Keap APP KEY',
				type: 'text',
				help_text: 'example: 08491f242aaa21e013fa56b26c1a9c72',
				tooltip: 'Input the Keap App Key. You can find this in Keap in ADMIN -> SETTINGS -> APPLICATION -> API -> ENCRYPTED KEY.'
			},
			infusionsoft_username: {
				label: 'Keap EMAIL ADDRESS',
				type: 'text',
				help_text: 'example: jsmith@example.com',
				tooltip: 'This is your individual email address that you use when logging in to Keap.'
			},
			infusionsoft_password: {
				label: 'Keap PASSWORD',
				type: 'text',
				help_text: '(cASE sENSITIVE)',
				tooltip: 'Enter the password you use to access your Keap account. This is CASE SENSITIVE.'
			}
		};
	},
	__discardChanges: esUtils.wrapPreventDefault(function () {
		this._form_reset();
	}),
	render: function () {
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var changes_made = this._form_areChangesMade();

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}),
			SlideOpenDown({open: changes_made},
				HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/InfusionSoft.js